import styled from "styled-components";

import { Card } from "./primitives";

// Blocking screen shown when chat context is missing/invalid (no chatId, or API
// returned 412 missing_chat_context / 400 invalid_request). Per PRD decision
// #11 the game UI must NOT render behind it.
const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space(6)};
`;

const Inner = styled.div`
  width: 100%;
  max-width: 360px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 20px;
  margin: ${({ theme }) => `${theme.space(4)} 0 ${theme.space(2)}`};
`;

const Body = styled.p`
  color: ${({ theme }) => theme.color.textDim};
  font-size: 14px;
  margin: 0;
`;

const Label = styled.div`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 12px;
  color: ${({ theme }) => theme.color.textFaint};
`;

export function ChatGate() {
  return (
    <Wrap>
      <Inner>
        <Card ticks>
          <Label>// rocky.v1</Label>
          <Title>Please open in chat</Title>
          <Body>
            Rocky lives in your group. Open the Mini App from the group&rsquo;s menu button so it
            knows which Rocky you mean.
          </Body>
        </Card>
      </Inner>
    </Wrap>
  );
}
